import { render } from "./UserStats.vue?vue&type=template&id=477508e6&scoped=true"
import script from "./UserStats.vue?vue&type=script&lang=js"
export * from "./UserStats.vue?vue&type=script&lang=js"

import "./UserStats.vue?vue&type=style&index=0&id=477508e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477508e6"]])

export default __exports__